import { render, staticRenderFns } from "./PackagingDrawer.vue?vue&type=template&id=421a4f0c&"
import script from "./PackagingDrawer.vue?vue&type=script&lang=js&"
export * from "./PackagingDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports